/**
 * 🔤 한글 초성 검색 유틸리티
 * matchSearch("김철수", "ㄱㅊㅅ") → true
 */

const CHOSUNG_LIST = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

export const getChosung = (str) => {
    if (!str) return "";
    let result = "";
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code >= 0xAC00 && code <= 0xD7A3) {
            result += CHOSUNG_LIST[Math.floor((code - 0xAC00) / 588)];
        } else {
            result += str[i];
        }
    }
    return result;
};

export const isChosungOnly = (query) => {
    if (!query) return false;
    return /^[ㄱ-ㅎ]+$/.test(query);
};

export const matchSearch = (target, query) => {
    if (!query) return true;
    if (!target) return false;
    if (target.toLowerCase().includes(query.toLowerCase())) return true;
    if (isChosungOnly(query)) return getChosung(target).includes(query);
    return false;
};
